import React from 'react';

interface PresenceDotProps {
  isOnline: boolean;
  size?: 'sm' | 'md';
}

const SIZE_CLASSES: Record<NonNullable<PresenceDotProps['size']>, string> = {
  sm: 'h-2 w-2',
  md: 'h-2.5 w-2.5',
};

export const PresenceDot = React.memo(function PresenceDot({
  isOnline,
  size = 'sm',
}: PresenceDotProps): React.ReactElement | null {
  if (!isOnline) return null;

  return (
    <span
      className={`absolute bottom-0 right-0 rounded-full bg-primary ring-1 ring-background ${SIZE_CLASSES[size]}`}
    />
  );
});
